import {isFeatureEnabled} from '@github-ui/feature-flags'
import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {codeViewAppBuilder} from './config/app-builder'
import {createCodeViewRoutes} from './routes/create-code-view-routes'

export const codeViewApp = codeViewAppBuilder.createDataRouterAppFromRoutes(createCodeViewRoutes(codeViewAppBuilder), {
  tanStackRouterEnabled: () => isFeatureEnabled('react_code_view_tanstack_router'),
})

registerDataRouterApp(codeViewApp)
